<div class="row-actions-container">
	<ng-container
		*ngIf="!keyExistsIn(row, 'editing') && !keyExistsIn(row, 'newRow') && !(!!row['STATUS'] && row['STATUS'] == 'CANCELED') && ('ACT_AUDIT' | haveAction: (actions ?? []) | async)">
		<button (click)="emitAction('ACT_AUDIT')"
				class="table-button"
				color="primary"
				mat-icon-button
				matTooltip="{{'LABEL_AUDIT' | translate}}">
			<mat-icon>history</mat-icon>
		</button>
	</ng-container>

	<ng-container
		*ngIf="!row.newRow && !row.editing && ('ACT_INSP_CONTAINER' | haveAction: (actions ?? []) | async)">
		<button (click)="emitAction('ACT_INSP_CONTAINER')"
				class="table-button"
				color="primary"
				mat-icon-button
				matTooltip="{{'LABEL_INSPECT_CONTAINER' | translate}}">
			<mat-icon>search</mat-icon>
		</button>
	</ng-container>

	<ng-container
		*ngIf="!row.newRow && !row.editing && ('ACT_COM_TRACKER' | haveAction: (actions ?? []) | async)">
		<button (click)="emitAction('ACT_COM_TRACKER')"
				class="table-button"
				color="primary"
				mat-icon-button
				matTooltip="{{'LABEL_COMMUNICATION_TRACKER' | translate}}">
			<mat-icon>chat</mat-icon>
		</button>
	</ng-container>
</div>
